// Example starter JavaScript for disabling form submissions if there are invalid fields
(function () {
  'use strict'

  // Fetch all the forms we want to apply custom Bootstrap validation styles to
  var forms = document.querySelectorAll('.needs-validation')

  // Loop over them and prevent submission
  Array.prototype.slice.call(forms)
    .forEach(function (form) {
      form.addEventListener('submit', function (event) {
        if (!form.checkValidity()) {
          event.preventDefault()
          event.stopPropagation()
        }

        form.classList.add('was-validated')
      }, false)
    })
})()

// When the user clicks on the button, scroll to the top of the document
function topFunction() {
	$("html, body").animate({ scrollTop: 0 });
}

function add_wishlist(id){
  $.post("/product/addWishlist",
      {proId: id},
  function(result){
    $("#liveToast").removeClass('hide').addClass('show')
    setTimeout(function () {
      $("#liveToast").removeClass('show').addClass('hide')
    },5000)
  });
}

function SendComment($form) {
	let btn = $form.find('.btn');
	let _text = btn.text();
	btn.html('<svg  width="20" height="20" style="enable-background:new 0 0 50 50;" xml:space="preserve"><use href="#loading"/></svg> Đang gửi').css('pointer-events', 'none').prop('disable', true);
	
  $("#commentRate").val($('[name="rating"]:checked').val() ? $('[name="rating"]:checked').val() : 0)

	$.post('/comment/send', $form.serialize())
		.done(function (data) {
			btn.html(_text).css('pointer-events', '').prop('disable', false);

			if (data.error_msg)
				$form.find('.comment_error').html(data.error_msg);
			else {
				$form.find('.comment_error').removeClass('text-danger').addClass('text-success').html(data.success_msg);
				$form.trigger("reset");
			}

		})
		.fail(function (jqXHR, textStatus) {
		});
	return false;
}

$("#frm-comment").submit(function (event) {
	event.preventDefault();
  event.stopPropagation();
  const form = $(this)
  
  if (!form[0].checkValidity()) {
    return true
  }
  form.removeClass('was-validated')
  SendComment(form);
  
  return true
});

function sidebar_open() {
  $('html').addClass('overflow-hidden');
  $("#menuSidebar").addClass('sidebar-open');
}

function sidebar_close() {
  $('html').removeClass('overflow-hidden');
  $("#menuSidebar").removeClass('sidebar-open');
}


$("body").on("click", '.reply-comment', function () {
	var parent_id = $(this).data('rel');


  var html = '<form id="frm-comment1" class="mt-3 needs-validation" action="comment/send" method="post" novalidate="novalidate">\
              <input type="hidden" name="item_id" value="' + $('#frm-comment [name="item_id" ]').val() + '">\
              <input type="hidden" name="reply_id" value="' + parent_id + '">\
              <input type="hidden" name="object_type" value="' + $('#frm-comment [name="object_type" ]').val() + '">\
              <p class="text-danger comment_error"></p>\
              <div class="mb-3">\
                  <textarea name="content" class="form-control" style="resize: none;" placeholder="Mời bạn để lại bình luận" rows="3" required></textarea>\
                  <div class="invalid-feedback">Vui lòng nhập bình luận</div>\
              </div>\
              <button type="submit" class="btn btn-submit">Gửi đánh giá</button>\
            </form>'

	if ($('#comment-' + parent_id).find("#frm-comment1").length)
		$("#frm-comment1").remove();
	else {
		$("#frm-comment1").remove();
		$('#comment-' + parent_id + ' .media-body').append(html);
	}

	$("#frm-comment1").submit(function (event) {
		event.preventDefault();
		event.stopPropagation();

    if ($(this)[0].checkValidity()) {
      $(this).removeClass('was-validated')
			SendComment($(this));
		}
	});

});

$(function () {
  $("[name='rating']").click(function () {
    $('#totalRate').html(`(${$(this).val()}/5)`)
  })
  $("#NewsletterForm").submit(function (event) {
    event.preventDefault();
    event.stopPropagation();
    const form = $(this)

    form.removeClass('was-validated')
    $('#newsletter').removeClass('is-invalid')
    form.find('.alert').addClass('d-none')
  
    var Email = $('#newsletter').val();
  
    let btn = form.find('.btn');
    let _text = btn.html();
    btn.html('<svg  width="20" height="20"  style="enable-background:new 0 0 50 50;" xml:space="preserve"><use href="#loading"/></svg> Đang gửi').css('pointer-events', 'none');
  
    if (Email) {
      $.post("/email/subscribe", { 'email': Email }, function (response) {
        btn.html(_text).css('pointer-events', '');
        if (response["IntResult"] > 0) {
          form.trigger('reset');
          form.find('.alert').removeClass('d-none')
        } else {
          form.addClass('was-validated')
          $('#newsletter').addClass('is-invalid')
          $("#NewsletterForm .invalid-feedback").html('Email này đã được đăng ký.')
        }
      })
    } else {
      btn.html(_text).css('pointer-events', '');
      $('#newsletter').addClass('is-invalid')
      form.addClass('was-validated')
      $("#NewsletterForm .invalid-feedback").html('Email không đúng định dạng')
    }
  
  });
})